import { FilterOperator, SortDirection } from "./enums";

export interface IFilter {
  PropertyName: string;
  Operator: FilterOperator;
  Value: any;
}

export class IPOCOFilter {
  constructor(
    public PropertyName?: string,
    public Operator?: FilterOperator,
    public Value?: any
  ) {}
}

export class Filter implements IFilter {
  PropertyName: string;
  Operator: FilterOperator;
  Value: any;

  constructor(PropertyName?: string, Operator?: FilterOperator, Value?: any) {
    this.PropertyName = PropertyName;
    this.Operator = Operator;
    this.Value = Value;
  }
}

export class SortItem {
  PropertyName: string;
  Direction: SortDirection;
}
